exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-result-header-title[data-v-0fe42da5] { width: 160px; float: left; font-size: 18px; white-space: nowrap;\n}\n.search-not-found[data-v-0fe42da5] {\n    margin: 100px 0 !important;\n}\n", ""]);

// exports
